import React, { useCallback, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Input, FormGroup, FormText } from "reactstrap";
import { Else, If, Then, When } from "react-if";
import styles from "./style.module.sass";

const PasswordToggle = ({ password, onChangePassword, className }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isCapsActive, setCapsActive] = useState(false);
  const toggleShowPassword = useCallback(() => setShowPassword(prevState => !prevState), []);
  const toggleCaps = useCallback(event => setCapsActive(event.getModifierState('CapsLock')), []);
  return (
    <>
      <FormGroup autoComplete="off" className={className}>
        <Input autoComplete="off" className={showPassword ? styles["login-input"] : styles["password-input"]} type="text" placeholder="Senha" value={password} onChange={onChangePassword} onMouseDown={toggleCaps} onKeyUp={toggleCaps}/>
        <div onClick={toggleShowPassword} className={styles.toggler}>
          <If condition={showPassword}>
            <Then>
              <FaEyeSlash color="#E14E0A" />
            </Then>
            <Else>
              <FaEye color="#E14E0A" />
            </Else>
          </If>
        </div>
      </FormGroup>
      <When condition={isCapsActive}>
        <FormText color="danger">Caps Lock ativo</FormText>
      </When>
    </>
  );
};

export default PasswordToggle;
